import React from 'react'

// components
import Typography from '@mui/material/Typography'

// containers
import ModalWrapper from 'components/shared/ModalWrapper'

const SitsSeparatelyModal = props => {
  return (
    <ModalWrapper
      title='Sit separately at Lunch'
      modalId='sitsSeparately'
      closeButton
    >
      <Typography variant='body1'>
        Your child will eat by themselves in our staffed HQ office away from
        other campers and their lunches.
      </Typography>
    </ModalWrapper>
  )
}

export default SitsSeparatelyModal
